import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import store from './store'
import {setI18n} from '@/libs/i18n'
import { sendPost, selectAccCdList, selectCommCodeList, selectComCdLists, sendPostFile, sendPostFileDown } from '@/libs/comm/transection';

import router from './router/index';
import VueCookies from "vue-cookies";

import '@/libs/sweet-alerts'
import '@/libs/sanitize'
import LoadScript from 'vue-plugin-load-script';
import VTooltip from 'v-tooltip'

import contContent from '@/views/contents/content/contContent'
import boardContent from '@/views/contents/content/boardContent'
import tiMainContent from '@/views_isoti/contents/mainContent'
import tiContContent from '@/views_isoti/contents/content/contContent'
import tiBoardContent from '@/views_isoti/contents/content/boardContent'
import mainContent from '@/views/contents/mainContent'

import '@toast-ui/editor/dist/toastui-editor.css';
import 'tui-color-picker/dist/tui-color-picker.css';
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css';

import VueMeta from 'vue-meta'

Vue.component('cont-content',contContent)
Vue.component('board-content',boardContent)
Vue.component('main-content',mainContent) 

Vue.component('ti-main-content',tiMainContent)
Vue.component('ti-cont-content',tiContContent)
Vue.component('ti-board-content',tiBoardContent)

Vue.use(VueCookies);
Vue.use(LoadScript);
Vue.use(VTooltip);

Vue.use(VueMeta)

let css = () => import('@/assets/scss/style.scss')

if(window.location.pathname.indexOf('/isoti')==0){
  css = () => import('@/assets/scss/isoti/style.scss')
  store.dispatch('setSiteContext', "isoti");
}else{
  store.dispatch('setSiteContext', "nisc");
}

const getComponent = function (comp) {
  if(comp != null && comp != ''){
   return () => import(`@/views${comp}.vue`) ;
  }
  return null;
}

Vue.prototype.$comp = getComponent;
Vue.prototype.$tran = sendPost;
Vue.prototype.$tranFile = sendPostFile;
Vue.prototype.$tranFileDown = sendPostFileDown;
Vue.prototype.$codeList = selectCommCodeList;
Vue.prototype.$codeLists = selectComCdLists;
Vue.prototype.$accList = selectAccCdList;


Vue.config.productionTip = false

Vue.prototype.$EventBus = new Vue();

css().then(() => {
  setI18n().then((i18n)=>{
    new Vue({
      router,
      store,
      i18n,
      render: h => h(App),
    }).$mount('#app')
  })
})